module.exports = __webpack_public_path__ + "media/canada-goose-1.b4619084.mp3";